// src/services/organizationService.js
import axios from "axios";
import { BACKEND_URL } from "../utils/envConfig";

const API_URL = `${BACKEND_URL}/organizations`;

// Organization Management
export const getAllOrganizations = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

export const getOrganizationById = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`);
  return response.data;
};

export const createOrganization = async (organizationData) => {
  const response = await axios.post(API_URL, organizationData);
  return response.data;
};

export const updateOrganization = async (id, organizationData) => {
  const response = await axios.put(`${API_URL}/${id}`, organizationData);
  return response.data;
};

export const deleteOrganization = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}`);
  return response.data;
};

// Get organizations for credit billing
export const getCreditOrganizations = async () => {
  const response = await axios.get(`${API_URL}/credit-eligible`);
  return response.data;
};

// Organization Tariff Management
export const getOrganizationTariff = async (organizationId) => {
  const response = await axios.get(`${API_URL}/${organizationId}/tariff`);
  return response.data;
};

export const setOrganizationTariff = async (organizationId, tariffId) => {
  const response = await axios.post(`${API_URL}/${organizationId}/tariff`, { tariffId });
  return response.data;
};

// Organization Outstanding Bills
export const getOrganizationOutstandingBills = async (organizationId) => {
  const response = await axios.get(`${API_URL}/${organizationId}/outstanding-bills`);
  return response.data;
};

// Organization Payment History
export const getOrganizationPaymentHistory = async (organizationId) => {
  const response = await axios.get(`${API_URL}/${organizationId}/payments`);
  return response.data;
};

export default {
  getAllOrganizations,
  getOrganizationById,
  createOrganization,
  updateOrganization,
  deleteOrganization,
  getCreditOrganizations,
  getOrganizationTariff,
  setOrganizationTariff,
  getOrganizationOutstandingBills,
  getOrganizationPaymentHistory
};
